import React from 'react';
import { Card, Col } from 'react-bootstrap';

type Props = {
  title: string;
  text: string | number;
  footer?: string;
  classNameText?: string;
};

export const SuperAdminCardMenu: React.FC<Props> = ({
  title,
  text,
  footer,
  classNameText,
}) => {
  return (
    <Col>
      <Card className="stat-card">
        <Card.Body>
          <Card.Title className="stat-title">{title}</Card.Title>
          <Card.Text className={classNameText || 'stat-value-blue'}>
            {text}
          </Card.Text>
        </Card.Body>
        {footer && (
          <Card.Footer>
            <small className="text-muted">{footer}</small>
          </Card.Footer>
        )}
      </Card>
    </Col>
  );
};
